import { render, staticRenderFns } from "./UsersSelect.vue?vue&type=template&id=ed668858&"
import script from "./UsersSelect.vue?vue&type=script&lang=js&"
export * from "./UsersSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports